function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

export { canUseDOM };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@reach/utils/can-use-dom/dist/reach-utils-can-use-dom.esm.js
// module id = szgV
// module chunks = 24